import React, { useEffect, useState } from "react";
import AdminDashboard from "../AdminDashboard";
import { Alert, Button, Col, Form, Row, Spinner } from "react-bootstrap";
import { basicConfig } from "../../../constants";
import axios from "axios";
import { validateEmail } from "../../../CommonMethods";
import { showNotificationG } from "../../../methods/notificationManager";

const SendMassMail = () => {
  const [loading, setLoading] = useState(false);

  const [showError, setShowError] = useState(false);

  const [sendAllcustomers, setSendAllCustomers] = useState(false);

  const [customRecipients, setCustomRecipients] = useState([]);

  const [mailToAdd, setMailToAdd] = useState("");

  const [isEmailValid, setIsEmailValid] = useState(true);

  const [recipientformValidated, setRecipientFormValidated] = useState(false);

  useEffect(() => {
    setIsEmailValid(validateEmail(mailToAdd));
  }, [mailToAdd]);

  const [formData, setFormData] = useState({
    subject: null,
    message: null,
    recipients: [],
  });

  const { subject, message, recipients } = formData;

  useEffect(() => {
    if (sendAllcustomers) {
      async function fetchCustomers() {
        setLoading(true);
        try {
          await axios
            .get(`${process.env.REACT_APP_API_URL}/users/`, basicConfig)
            .catch((_) => {})
            .then((response) => {
              if (response && response.status === 200) {
                let customerEmails = [];

                for (const customer of response.data ?? []) {
                  if (customer?.email !== null) {
                    customerEmails.push(customer.email);
                  }
                }

                setFormData((f) => ({ ...f, recipients: customerEmails }));
              }
            });
        } catch (_) {}
        setLoading(false);
      }

      // fetchCustomers();
    } else {
      setFormData((f) => ({ ...f, recipients: customRecipients }));
    }
  }, [sendAllcustomers, customRecipients]);

  function addRecipient(e) {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setRecipientFormValidated(true);
    } else {
      if (isEmailValid) {
        setRecipientFormValidated(false);
        setCustomRecipients([...customRecipients, mailToAdd.trim()]);
        setMailToAdd("");
      }
    }
  }

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  async function sendMail(e) {
    e.preventDefault();
    setLoading(true);

    // await axios
    //   .post(
    //     `${process.env.REACT_APP_API_URL}/users/sendmail/`,
    //     JSON.stringify(formData),
    //     basicConfig
    //   )
    //   .catch((_) => {
    //     setShowError(true);
    //   })
    //   .then((response) => {
    //     if (response && response.status === 200) {
    //       setLoading(false);
    //       // succuss
    //       showNotificationG("Email(s) Sent.");
    //       setCustomRecipients([]);
    //       setSendAllCustomers(false);
    //     } else {
    //       setLoading(false);
    //       setShowError(true);
    //     }
    //   });

    setLoading(false);
  }

  return (
    <AdminDashboard>
      <>
        {showError && (
          <Alert
            variant="danger"
            onClose={() => {
              setShowError(false);
            }}
            dismissible
          >
            <Alert.Heading>Error fetching.</Alert.Heading>
          </Alert>
        )}
        {loading && <Spinner animation="grow" />}
        <div className="admin_content">
          <div className="admin_content_header">
            <h4>Send Mass Mail</h4>
          </div>

          <div className="admin_content_content">
            <Row>
              <Col sm={6}>
                <Form>
                  <Form.Group className="mb-3">
                    <Form.Check
                      type="checkbox"
                      label="All Customers"
                      checked={sendAllcustomers}
                      onChange={(e) => setSendAllCustomers(e.target.checked)}
                    />
                  </Form.Group>
                </Form>

                {!sendAllcustomers && (
                  <Form
                    noValidate
                    validated={recipientformValidated}
                    onSubmit={(e) => addRecipient(e)}
                  >
                    <Form.Group className="mb-3">
                      <Form.Label>Add Mail</Form.Label>
                      <Form.Control
                        type="text"
                        value={mailToAdd}
                        isInvalid={
                          mailToAdd.trim() !== "" ? !isEmailValid : false
                        }
                        onChange={(e) => setMailToAdd(e.target.value)}
                        required
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter a Valid Email Address
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Button type="submit">Add Recipient</Button>
                  </Form>
                )}

                {!sendAllcustomers && (
                  <Form>
                    <Form.Group className="mb-3">
                      {(customRecipients ?? []).map((v, i) => {
                        return <span key={i}>{v + ", "}</span>;
                      })}
                    </Form.Group>
                  </Form>
                )}

                {!sendAllcustomers && (
                  <Button onClick={() => setCustomRecipients([])}>
                    Clear Recipients
                  </Button>
                )}

                <Form onSubmit={(e) => sendMail(e)}>
                  {showError && (
                    <Alert
                      variant="danger"
                      onClose={() => {
                        setShowError(false);
                      }}
                      dismissible
                    >
                      <Alert.Heading>Error Sending Mail.</Alert.Heading>
                    </Alert>
                  )}

                  <Form.Group className="mb-3">
                    <Form.Label>Subject </Form.Label>
                    <Form.Control
                      type="text"
                      name="subject"
                      value={subject}
                      onChange={(e) => onChange(e)}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <label htmlFor="message">Message</label>
                    <textarea
                      name="message"
                      className="form-control"
                      value={message}
                      onChange={(e) => onChange(e)}
                      required
                      rows={8}
                    ></textarea>
                  </Form.Group>

                  <Button
                    type="submit"
                    // disabled={
                    //   loading ||
                    //   (!sendAllcustomers &&
                    //     (customRecipients ?? []).length < 1) ||
                    //   (sendAllcustomers && (recipients ?? []).length < 1)
                    // }
                    disabled={true}
                  >
                    {loading ? "SENDING..." : "SEND MAIL"}
                  </Button>
                </Form>
              </Col>
            </Row>
          </div>
        </div>
      </>
    </AdminDashboard>
  );
};

export default SendMassMail;
